module.exports = __webpack_public_path__ + "img/INTERIOR-XL7-1.fd111b58.jpg";